import { axiosJSONInstance } from '@/config';
import type {
  ShippingRule,
  ShippingRuleCreatePayload,
  ShippingRuleUpdatePayload,
  ShippingRulesListResponse,
  ShippingRuleResponse,
  ShippingRuleModeResponse,
  EvaluateShippingRulesRequest,
  EvaluateShippingRulesResponse,
} from '@/types';

const BASE = '/merchants/shipping-rules';

export const getShippingRulesMode = async (): Promise<ShippingRuleModeResponse> => {
  const res = await axiosJSONInstance.get(`${BASE}/mode`);
  return res.data;
};

export const listShippingRules = async (): Promise<ShippingRulesListResponse> => {
  const res = await axiosJSONInstance.get(`${BASE}`);
  return res.data;
};

export const showShippingRule = async (uid: string): Promise<ShippingRuleResponse> => {
  const res = await axiosJSONInstance.get(`${BASE}/${uid}`);
  return res.data;
};

export const createShippingRule = async (
  payload: ShippingRuleCreatePayload,
): Promise<ShippingRuleResponse> => {
  const res = await axiosJSONInstance.post(`${BASE}`, payload);
  return res.data;
};

export const updateShippingRule = async (
  uid: string,
  payload: ShippingRuleUpdatePayload,
): Promise<ShippingRuleResponse> => {
  const res = await axiosJSONInstance.patch(`${BASE}/${uid}`, payload);
  return res.data;
};

export const toggleShippingRule = async (uid: string): Promise<{ object: { is_active: boolean } }> => {
  const res = await axiosJSONInstance.patch(`${BASE}/${uid}/toggle`);
  return res.data;
};

export const deleteShippingRule = async (uid: string): Promise<{ object: { uid: string } }> => {
  const res = await axiosJSONInstance.delete(`${BASE}/${uid}`);
  return res.data;
};

/** RS-16 — POST /merchants/orders/evaluate-shipping-rules. */
export const evaluateShippingRules = async (
  payload: EvaluateShippingRulesRequest,
): Promise<EvaluateShippingRulesResponse> => {
  const res = await axiosJSONInstance.post(`/merchants/orders/evaluate-shipping-rules`, payload);
  return res.data;
};
